import {cohortsStore} from 'common/report/stores/cohorts';
import {createLegacyStoreContextHook} from 'common/util/react';

export const useCohorts = createLegacyStoreContextHook(cohortsStore);
